import { session } from './session';

class AnalyticService {
	constructor() {
		this.Session = session;
		this.ga = window.ga;

		this.dimensionMap = {
			timestamp: 'dimension1',
			query: 'dimension2',
			bam_link_id: 'dimension3',
			user_id: 'dimension4',
			is_admin: 'dimension5',
			group_field: 'dimension6',
			org_id: 'dimension7',
			email: 'dimension8',
		};
		this.propertyID = '64241223-1';
	}

	setUp(isRelease, user) {
		// Opt-out of all analytics and tracking when not in release
		if (!isRelease) {
			window[`ga-disable-UA-${this.propertyID}`] = true;
			return;
		}

		if (!user) return;

		const displayName = user.firstName && user.lastName ?
			`${user.firstName} ${user.lastName[0]}` : user.userName;
		this.ga('set', {'&uid': displayName});
	}

	trackEvent(category, action, label, params) {
		params = this.buildEventParams(params);
		const gaParams = {};

		Object.keys(params).forEach((key) => {
			if (key in this.dimensionMap) {
				gaParams[this.dimensionMap[key]] = params[key];
			}
		});

		this.ga('send', 'event', category, action, label, gaParams);
	}

	buildEventParams(params) {
		params = params || {};

		if (this.Session) {
			Object.assign(params, {
				timestamp: new Date().toISOString(),
				is_admin: this.Session.isAdmin,
				org_id: this.Session.orgId,
				email: this.Session.email || params.email || 'Unknown',
			});
		}

		return params;
	}
}

export default new AnalyticService();
